// extracted by mini-css-extract-plugin
export default {"container":"longAlert_container__mRptP","messageContainer":"longAlert_messageContainer__9QV2w","body":"longAlert_body__1vluA"};